import { render, staticRenderFns } from "./CardInfoSectionWithIcon.vue?vue&type=template&id=29dca06f"
import script from "./CardInfoSectionWithIcon.vue?vue&type=script&lang=js"
export * from "./CardInfoSectionWithIcon.vue?vue&type=script&lang=js"
import style0 from "./CardInfoSectionWithIcon.vue?vue&type=style&index=0&id=29dca06f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports